function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import WebsiteIcon from './WebsiteIcon';
import Button from './Button';

import './WebCookieConsent.css';

var WebCookieConsent = function (_Component) {
    _inherits(WebCookieConsent, _Component);

    function WebCookieConsent(props) {
        _classCallCheck(this, WebCookieConsent);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleDismiss = function (e) {
            e.preventDefault();
            _this.props.onDecline();
        };

        return _this;
    }

    WebCookieConsent.prototype.shouldDisplay = function shouldDisplay() {
        return this.props.display;
    };

    WebCookieConsent.prototype.getHeading = function getHeading() {
        if (this.props.heading) {
            return this.props.heading;
        }
        return 'Cookies';
    };

    WebCookieConsent.prototype.getOrganisationName = function getOrganisationName() {
        if (this.props.organisationName) {
            return this.props.organisationName;
        }
        return 'We';
    };

    WebCookieConsent.prototype.getCookiePolicyAddon = function getCookiePolicyAddon() {
        if (this.props.cookiePolicyLink) {
            return React.createElement(
                'span',
                null,
                ', in accordance with our ',
                this.props.cookiePolicyLink
            );
        }
        return '';
    };

    WebCookieConsent.prototype.render = function render() {
        return React.createElement(
            'div',
            { className: 'WebCookieConsent', 'data-display': this.shouldDisplay() },
            React.createElement(
                'div',
                { className: 'WebCookieConsent-content' },
                React.createElement(
                    'span',
                    { className: 'WebCookieConsent-icon' },
                    React.createElement(WebsiteIcon, { name: 'cookie-bite', fill: true })
                ),
                React.createElement(
                    'div',
                    { className: 'WebCookieConsent-heading' },
                    this.getHeading()
                ),
                React.createElement(
                    'div',
                    { className: 'WebCookieConsent-body' },
                    this.getOrganisationName(),
                    ' would like to place cookies to understand how our website is used',
                    this.getCookiePolicyAddon(),
                    '.'
                ),
                React.createElement(
                    'div',
                    { className: 'WebCookieConsent-buttons' },
                    React.createElement(Button, { className: 'WebCookieConsent-decline-button', label: 'Decline', subtle: true, width: '100px', onClick: this.props.onDecline }),
                    React.createElement(Button, { className: 'WebCookieConsent-accept-button', label: 'Accept', intent: 'primary', width: '120px', onClick: this.props.onAccept })
                )
            ),
            React.createElement(
                'div',
                { className: 'WebCookieConsent-dismiss' },
                React.createElement(
                    'a',
                    { href: '#', onClick: this.handleDismiss, title: 'Decline' },
                    '\xD7'
                )
            )
        );
    };

    return WebCookieConsent;
}(Component);

export default WebCookieConsent;